import { countryCodeEnum } from '@/constants/country'

export const COUNTRY_ISLAND = [
  countryCodeEnum.TUVALU,
  countryCodeEnum.NAURU,
  countryCodeEnum.PALAU,
  countryCodeEnum.MARSHALL_ISLANDS,
  countryCodeEnum.SVALBARD,
]

export const COUNTRY_WHITELIST = [
  countryCodeEnum.ALAND_ISLANDS,
  countryCodeEnum.ANDORRA,
  countryCodeEnum.AUSTRIA,
  countryCodeEnum.BELGIUM,
  countryCodeEnum.BENIN,
  countryCodeEnum.BULGARIA,
  countryCodeEnum.CAMEROON,
  countryCodeEnum.CANADA,
  countryCodeEnum.CAPE_VERDE,
  countryCodeEnum.CHAD,
  countryCodeEnum.CHILE,
  countryCodeEnum.COLOMBIA,
  countryCodeEnum.DENMARK,
  countryCodeEnum.EQUATORIAL_GUINEA,
  countryCodeEnum.ESTONIA,
  countryCodeEnum.FAROE_ISLAND,
  countryCodeEnum.FIJI,
  countryCodeEnum.FINLAND,
  countryCodeEnum.FRANCE,
  countryCodeEnum.GERMANY,
  countryCodeEnum.GREENLAND,
  countryCodeEnum.IRELAND,
  countryCodeEnum.ITALY,
  countryCodeEnum.LUXEMBOURG,
  countryCodeEnum.MADAGASCAR,
  countryCodeEnum.MALAWI,
  countryCodeEnum.MALDIVES,
  countryCodeEnum.MARSHALL_ISLANDS,
  countryCodeEnum.MAURITANIA,
  countryCodeEnum.MAYOTTE,
  countryCodeEnum.MEXICO,
  countryCodeEnum.MONACO,
  countryCodeEnum.MONTSERRAT,
  countryCodeEnum.NEW_ZEALAND,
  countryCodeEnum.NIGER,
  countryCodeEnum.NORWAY,
  countryCodeEnum.PALAU,
  countryCodeEnum.PORTUGAL,
  countryCodeEnum.SAINT_VINCENT_AND_THE_GRENADINES,
  countryCodeEnum.SAN_MARINO,
  countryCodeEnum.SINGAPORE,
  countryCodeEnum.SOUTH_AFRICA,
  countryCodeEnum.SOUTH_GEORGIA,
  countryCodeEnum.SOUTH_KOREA,
  countryCodeEnum.ST_HELENA,
  countryCodeEnum.SVALBARD,
  countryCodeEnum.SWAZILAND,
  countryCodeEnum.SWEDEN,
  countryCodeEnum.SWITZERLAND,
  countryCodeEnum.TURKS_AND_CAICOS_ISLANDS,
  countryCodeEnum.UNITED_KINGDOM,
  countryCodeEnum.URUGUAY,
  countryCodeEnum.UZBEKISTAN,
  countryCodeEnum.VATICAN_CITY_STATE,
  countryCodeEnum.VIRGIN_ISLANDS,
  countryCodeEnum.WALLIS_FUTUNA,
]

// ***GREYLIST***
export const COUNTRY_GREYLIST = [
  countryCodeEnum.ALGERIA,
  countryCodeEnum.ANGOLA,
  countryCodeEnum.ANGUILLA,
  countryCodeEnum.ANTIGUA_AND_BARBUDA,
  countryCodeEnum.ARGENTINA,
  countryCodeEnum.ARUBA,
  countryCodeEnum.BAHAMAS,
  countryCodeEnum.BAHRAIN,
  countryCodeEnum.BANGLADESH,
  countryCodeEnum.BELIZE,
  countryCodeEnum.BHUTAN,
  countryCodeEnum.BOLIVIA,
  countryCodeEnum.BOTSWANA,
  countryCodeEnum.BRUNEI_DARUSSALAM,
  countryCodeEnum.CHRISTMAS_ISLAND,
  countryCodeEnum.COCOS_ISLANDS,
  countryCodeEnum.COOK_ISLANDS,
  countryCodeEnum.COSTA_RICA,
  countryCodeEnum.CHINA,
  countryCodeEnum.CYPRUS,
  countryCodeEnum.CZECH_REPUBLIC,
  countryCodeEnum.DOMINICA,
  countryCodeEnum.DOMINICAN_REPUBLIC,
  countryCodeEnum.EGYPT,
  countryCodeEnum.EL_SALVADOR,
  countryCodeEnum.FRENCH_GUIANA,
  countryCodeEnum.FRENCH_POLYNESIA,
  countryCodeEnum.GABON,
  countryCodeEnum.GAMBIA,
  countryCodeEnum.GEORGIA,
  countryCodeEnum.GHANA,
  countryCodeEnum.GREECE,
  countryCodeEnum.GRENADA,
  countryCodeEnum.GUADELOUPE,
  countryCodeEnum.GUATEMALA,
  countryCodeEnum.GUERNSEY,
  countryCodeEnum.GUYANA,
  countryCodeEnum.HEARD_MCDONALD_ISLANDS,
  countryCodeEnum.HONDURAS,
  countryCodeEnum.HONG_KONG,
  countryCodeEnum.HUNGARY,
  countryCodeEnum.ICELAND,
  countryCodeEnum.INDIA,
  countryCodeEnum.INDONESIA,
  countryCodeEnum.ISLE_OF_MAN,
  countryCodeEnum.JAPAN,
  countryCodeEnum.JERSEY,
  countryCodeEnum.KUWAIT,
  countryCodeEnum.KYRGYZSTAN,
  countryCodeEnum.LAOS,
  countryCodeEnum.LATVIA,
  countryCodeEnum.LESOTHO,
  countryCodeEnum.LIECHTENSTEIN,
  countryCodeEnum.LITHUANIA,
  countryCodeEnum.MACAO,
  countryCodeEnum.MALAYSIA,
  countryCodeEnum.MARTINIQUE,
  countryCodeEnum.MAURITIUS,
  countryCodeEnum.MONGOLIA,
  countryCodeEnum.NAMIBIA,
  countryCodeEnum.NAURU,
  countryCodeEnum.NEPAL,
  countryCodeEnum.NETHERLANDS,
  countryCodeEnum.NEW_CALEDONIA,
  countryCodeEnum.NIGERIA,
  countryCodeEnum.NIUE,
  countryCodeEnum.NORFOLK_ISLAND,
  countryCodeEnum.PANAMA,
  countryCodeEnum.PARAGUAY,
  countryCodeEnum.PERU,
  countryCodeEnum.PITCAIRN,
  countryCodeEnum.POLAND,
  countryCodeEnum.QATAR,
  countryCodeEnum.REUNION,
  countryCodeEnum.ROMANIA,
  countryCodeEnum.SAINT_BARTHELEMY,
  countryCodeEnum.SAINT_LUCIA,
  countryCodeEnum.SAMOA,
  countryCodeEnum.SAUDI_ARABIA,
  countryCodeEnum.SEYCHELLES,
  countryCodeEnum.SLOVAKIA,
  countryCodeEnum.SOLOMON_ISLANDS,
  countryCodeEnum.SPAIN,
  countryCodeEnum.SRI_LANKA,
  countryCodeEnum.ST_KITTS_NEVIS,
  countryCodeEnum.ST_PIERRE_MIQUELON,
  countryCodeEnum.SURINAME,
  countryCodeEnum.TAIWAN,
  countryCodeEnum.TAJIKISTAN,
  countryCodeEnum.THAILAND,
  countryCodeEnum.TIMOR_LESTE,
  countryCodeEnum.TOGO,
  countryCodeEnum.TOKELAU,
  countryCodeEnum.TONGA,
  countryCodeEnum.TURKMENISTAN,
  countryCodeEnum.VIETNAM,
  countryCodeEnum.ARMENIA,
  countryCodeEnum.AUSTRALIA,
  countryCodeEnum.AZERBAIJAN,
  countryCodeEnum.BRAZIL,
  countryCodeEnum.DJIBOUTI,
  countryCodeEnum.ECUADOR,
  countryCodeEnum.ISRAEL,
  countryCodeEnum.KAZAKHSTAN,
  countryCodeEnum.KENYA,
  countryCodeEnum.KIRIBATI,
  countryCodeEnum.MALTA,
  countryCodeEnum.MICRONESIA,
  countryCodeEnum.MOROCCO,
  countryCodeEnum.OMAN,
  countryCodeEnum.TURKEY,
  countryCodeEnum.UNITED_ARAB_EMIRATES,
  countryCodeEnum.BRITISH_INDIAN_OCEAN,
  countryCodeEnum.FALKLAND_ISLANDS,
]

export const CURRENCY_GREYLIST = countryCode => {
  switch (countryCode) {
    default:
      return ['USD', 'USC', 'EUR', 'GBP']
  }
}

export const CURRENCY_WHITELIST = countryCode => {
  switch (countryCode) {
    default:
      return ['USD', 'USC', 'EUR', 'GBP']
  }
}

// Define and modify in constants for router guard
// showIbt = COUNTRY_IBT.includes(parseInt(store.state.common.countryCode))
export const COUNTRY_IBT = [...COUNTRY_WHITELIST, ...COUNTRY_GREYLIST]
